import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Thanks from "./pages/Thanks";
import PlanDetail from "./pages/PlanDetail";
import StyleBriefing from "./pages/StyleBriefing";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import LanguageSwitcher from "./components/LanguageSwitcher";
import SalonDemo from "./pages/demos/SalonDemo";
import RestaurantDemo from "./pages/demos/RestaurantDemo";
import PhotographerDemo from "./pages/demos/PhotographerDemo";
import MechanicDemo from "./pages/demos/MechanicDemo";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function NotFound() {
  return (
    <main className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-xl text-center space-y-5">
        <p className="text-sm font-semibold tracking-wide uppercase text-teal-700">404</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900">Página não encontrada</h1>
        <p className="text-lg text-slate-600">
          O endereço que procuraste não existe ou foi movido.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-teal-700 px-6 py-3 font-medium text-white transition-colors hover:bg-teal-800"
          data-testid="not-found-home-link"
        >
          Voltar ao início
        </Link>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LanguageSwitcher />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/planos/:planId" element={<PlanDetail />} />
        <Route path="/plano/:planId" element={<PlanDetail />} />
        <Route path="/briefing" element={<StyleBriefing />} />
        <Route path="/thanks" element={<Thanks />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/demo/salon" element={<SalonDemo />} />
        <Route path="/demo/restaurant" element={<RestaurantDemo />} />
        <Route path="/demo/photographer" element={<PhotographerDemo />} />
        <Route path="/demo/mechanic" element={<MechanicDemo />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
